function Marquee() {
  const features = [
    "AI Viral Highlights (Live)",
    "Auto Captions (Soon)",
    "Custom Thumbnails (Soon)",
    "Cinematic Recaps (Soon)",
    "AI Music Matching (Soon)",
    "Social Automation (Soon)",
  ];

  return (
    <div className="border-t border-b border-border py-3.5 overflow-hidden bg-bg-secondary">
      <div className="marquee-track flex w-max animate-marquee">
        {/* Render features twice for seamless looping */}
        {[...features, ...features].map((feature, index) => (
          <div
            key={index}
            className="font-space flex items-center gap-5 px-9 text-[9px] tracking-[4px] uppercase whitespace-nowrap"
            style={{ color: '#666666' }}
          >
            <span>{feature}</span>
            <div className="w-[3px] h-[3px] bg-orange flex-shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
